var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-layout'),_c('audio',{ref:"audio",attrs:{"src":_vm.activeSound,"preload":"","id":"audio","muted":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }